import React, { useMemo } from "react";
import FlightOfferResultCardLayout from "../FlightOfferResultCardLayout";
import { useSearch } from "../../../../contexts/SearchContext";
import { buildPricedSelfComposeCombinedOffer } from "./selfComposeSummaryUtils";
import "./FlightBuilderSummaryCard.css";

export default function FlightBuilderSummaryCard({
  outboundDeal,
  inboundDeal,
  roomInfo,
}) {
  const { calculateLDSDealFareForRoomsComposition } = useSearch();
  const combinedOffer = useMemo(() => {
    if (!outboundDeal || !inboundDeal) return null;
    return buildPricedSelfComposeCombinedOffer(
      outboundDeal,
      inboundDeal,
      roomInfo,
      calculateLDSDealFareForRoomsComposition
    );
  }, [
    outboundDeal,
    inboundDeal,
    roomInfo,
    calculateLDSDealFareForRoomsComposition,
  ]);

  return (
    <div className="fsc-bsum" dir="rtl">
      {combinedOffer ? (
        <div className="fsc-bsum__preview">
          <div className="fsc-bsum__preview-card">
            <FlightOfferResultCardLayout
              offer={combinedOffer}
              isCheapest={false}
              hidePrimaryCta
            />
          </div>
        </div>
      ) : null}
    </div>
  );
}
